import { api } from "@/builders/axios";

interface ActivationOrDeactivationProps {
  is_active: boolean;
  reason: string;
}

export const activate_or_deactivate = function (variables: {
  username: string;
  data: ActivationOrDeactivationProps;
}) {
  const { username, data } = variables;
  return api.post(`/guardians/${username}/activate-or-deactivate`, data);
};
